<template>
  <div
      class="w-full text-slate-100"
      dir="rtl"
  >
    <div style="max-width: 92%" class="w-full mx-auto space-y-2 px-3 sm:px-4 lg:px-6 py-2">
      <div
          class="w-full rounded-3xl border border-white/10
                 bg-gradient-to-br from-slate-950/95 via-slate-900/90 to-slate-950/95
                 backdrop-blur-2xl shadow-2xl shadow-black/40 flex flex-col overflow-hidden"
      >
        <!-- Header -->
        <div
            class="border-b border-white/10 bg-gradient-to-l from-slate-950 via-slate-900 to-slate-950 px-4 md:px-6 py-4">
          <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div class="flex items-center gap-3 min-w-0">
              <div
                  style="max-width: 50px"
                  class="w-11 h-11  rounded-2xl border border-amber-400/25 bg-amber-400/10
                         flex items-center justify-center shadow-lg shadow-amber-500/10 flex-shrink-0"
              >
                <svg class="w-5 h-5 text-amber-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                </svg>
              </div>

              <div class="min-w-0">
                <h2 class="text-base md:text-lg font-black text-slate-50">
                  لیست سفارش‌های حضوری
                </h2>
                <p class="text-xs md:text-sm text-slate-400 mt-1">
                  جستجو، فیلتر، مشاهده جزئیات و وضعیت مرجوعی سفارش‌ها
                </p>
              </div>
            </div>

            <div class="flex items-center gap-2 flex-wrap">
              <div
                  class="text-xs md:text-sm text-slate-300 bg-slate-800/60 px-4 py-2 rounded-2xl border border-white/10"
              >
                نمایش
                <span class="text-amber-300 font-black mx-1">{{ orders.items.length }}</span>
                از
                <span class="text-emerald-300 font-black mx-1">{{ orders.total }}</span>
                سفارش
              </div>
            </div>
          </div>
        </div>

        <!-- Filters -->
        <div class="p-4 border-b border-white/10 bg-slate-950/45">
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-12 gap-3 items-end">
            <div class="xl:col-span-2">
              <label class="block text-[11px] text-slate-400 mb-1.5 pr-1">
                وضعیت سفارش
              </label>

              <select
                  v-model="localOrdersFilters.status"
                  class="w-full px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 text-right
                         focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20 outline-none transition-all"
              >
                <option value="">همه وضعیت‌ها</option>
                <option value="dr">پیش‌نویس</option>
                <option value="cf">نهایی شده</option>
                <option value="ca">لغو شده</option>
                <option value="re">برگشت از خرید</option>
              </select>
            </div>

            <div class="xl:col-span-4">
              <label class="block text-[11px] text-slate-400 mb-1.5 pr-1">
                جستجو
              </label>

              <div class="relative">
                <input
                    v-model="localOrdersFilters.search"
                    class="w-full px-4 py-2.5 pl-10 bg-slate-800/80 text-sm rounded-2xl border border-white/10 text-right
                           placeholder-slate-500 focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20
                           outline-none transition-all"
                    placeholder="جستجو بر اساس مشتری، شماره، کد سفارش..."
                    @keyup.enter="$emit('fetch-orders')"
                />

                <svg class="w-4 h-4 text-slate-500 absolute left-3 top-1/2 transform -translate-y-1/2" fill="none"
                     stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
              </div>
            </div>

            <div class="xl:col-span-4" v-if="false">
              <label class="block text-[11px] text-slate-400 mb-1.5 pr-1">
                بازه تاریخ
              </label>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <input
                    type="date"
                    v-model="localOrdersFilters.date_from"
                    class="w-full px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 text-right
                           focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20 outline-none transition-all"
                />

                <input
                    type="date"
                    v-model="localOrdersFilters.date_to"
                    class="w-full px-3 py-2.5 bg-slate-800/80 text-sm rounded-2xl border border-white/10 text-right
                           focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20 outline-none transition-all"
                />
              </div>
            </div>

            <div class="xl:col-span-2">
              <label class="block text-[11px] text-transparent mb-1.5 pr-1">
                عملیات
              </label>

              <div class="flex items-center justify-start gap-2">
                <button
                    @click="$emit('apply-orders-filters')"
                    class="h-[42px] w-[88px] px-3 bg-gradient-to-l from-amber-400 to-orange-500 text-slate-950 text-xs rounded-2xl
                           hover:from-amber-300 hover:to-orange-400 transition-all duration-200 hover:scale-[1.02]
                           font-black inline-flex gap-1.5 items-center justify-center shadow-lg shadow-amber-500/15 flex-none"
                >
                  <svg class="w-4 h-4 flex-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"/>
                  </svg>
                  اعمال
                </button>

                <button
                    @click="$emit('clear-orders-filters')"
                    class="h-[42px] w-[78px] px-3 bg-slate-800/80 text-slate-300 text-xs rounded-2xl border border-white/10
                           hover:bg-slate-700/80 hover:text-slate-100 transition-all duration-200
                           inline-flex items-center justify-center flex-none"
                >
                  حذف
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="overflow-auto flex-1">
          <table class="w-full min-w-[980px] text-sm">
            <thead class="bg-slate-950/95 border-b border-white/10 text-slate-300 sticky top-0 z-10">
            <tr>
              <th class="px-4 py-3 text-center font-bold text-xs">تاریخ ثبت</th>
              <th class="px-4 py-3 text-center font-bold text-xs">کد پیگیری</th>
              <th class="px-4 py-3 text-right font-bold text-xs">مشتری</th>
              <th class="px-4 py-3 text-center font-bold text-xs">مبلغ و مرجوعی</th>
              <th class="px-4 py-3 text-center font-bold text-xs">وضعیت</th>
              <th class="px-4 py-3 text-center font-bold text-xs">عملیات</th>
            </tr>
            </thead>

            <tbody class="divide-y divide-white/5">
            <tr
                v-for="o in orders.items"
                :key="o.id"
                class="group hover:bg-slate-800/35 transition-all duration-200"
            >
              <!-- Date -->
              <td class="px-4 py-4 whitespace-nowrap text-center">
                <div
                    class="inline-flex flex-col items-center justify-center rounded-2xl bg-slate-800/45 border border-white/5 px-3 py-2">
                  <span class="text-slate-200 text-xs font-medium">
                    {{ o.date_time || o.created_at || '---' }}
                  </span>
                </div>
              </td>

              <!-- ID -->
              <td class="px-4 py-4 text-center">
                <div
                    class="inline-flex items-center justify-center min-w-[58px] h-9 rounded-2xl
                           bg-cyan-400/10 border border-cyan-400/20 text-cyan-200 font-black text-sm"
                >
                  #{{ o.id }}
                </div>
              </td>

              <!-- Customer -->
              <td class="px-4 py-4 whitespace-nowrap">
                <div class="flex items-center gap-3">
                  <div
                      style="max-width: 70px"
                      class="w-10 h-10 rounded-2xl bg-gradient-to-br from-slate-700 to-slate-900
                             border border-white/10 flex items-center justify-center text-slate-200 font-black flex-none"
                  >
                    {{ customerInitial(o) }}
                  </div>

                  <div class="flex flex-col min-w-0">
                    <span class="text-slate-100 font-bold text-sm truncate">
                      {{ o.customer_name || 'بدون نام' }}
                    </span>
                    <span class="text-slate-500 text-xs mt-1">
                      {{ o.customer_phone || 'بدون شماره' }}
                    </span>
                  </div>
                </div>
              </td>

              <!-- Amount -->
              <td class="px-4 py-4 text-center">
                <div
                    class="mx-auto w-full max-w-[260px] rounded-2xl border p-3"
                    :class="hasReturns(o)
                      ? 'border-orange-400/20 bg-orange-500/5'
                      : 'border-emerald-400/15 bg-emerald-500/5'"
                >
                  <div class="flex items-center justify-between gap-3">
                    <span class="text-[11px] text-slate-400">
                      مبلغ نهایی
                    </span>

                    <span
                        class="text-sm font-black"
                        :class="hasReturns(o) ? 'text-cyan-200' : 'text-emerald-300'"
                    >
                      {{ displayFinalAmount(o) | toMoney(0) }}
                    </span>
                  </div>

                  <div v-if="hasReturns(o)" class="mt-3 space-y-2">
                    <div class="flex items-center justify-between gap-3 text-[11px]">
                      <span class="text-slate-500">
                        اصل فاکتور
                      </span>
                      <span class="text-slate-400 line-through">
                        {{ o.final_amount | toMoney(0) }}
                      </span>
                    </div>

                    <div class="flex items-center justify-between gap-3 text-[11px]">
                      <span class="text-orange-200/80">
                        کسر مرجوعی
                      </span>
                      <span class="text-orange-300 font-black">
                        {{ o.total_returned_amount | toMoney(0) }}
                      </span>
                    </div>

                    <div class="h-px bg-white/10"></div>

                    <div class="flex items-center justify-center">
                      <span
                          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-xl border border-orange-400/25
                                 bg-orange-400/10 text-orange-200 text-[10px] font-bold"
                      >
                        <svg class="w-3.5 h-3.5 flex-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
                        </svg>
                        دارای مرجوعی
                        <template v-if="o.returns_count">
                          / {{ o.returns_count }} مورد
                        </template>
                      </span>
                    </div>
                  </div>
                </div>
              </td>

              <!-- Status -->
              <td class="px-4 py-4 text-center">
                <div class="flex flex-col items-center gap-2">
                  <span
                      class="px-3 py-1.5 rounded-2xl text-xs border font-bold"
                      :class="statusBadgeClass(o.status)"
                  >
                    {{ posStatusLabel(o.status) }}
                  </span>

                  <span
                      v-if="hasReturns(o)"
                      class="px-2.5 py-1 rounded-xl text-[10px] border font-bold"
                      :class="returnTypeClass(o)"
                  >
  {{ returnTypeLabel(o) }}
</span>
                </div>
              </td>

              <!-- Actions -->
              <td class="px-4 py-4 text-center whitespace-nowrap">
                <div class="flex items-center justify-center gap-2">
                  <button
                      @click="$emit('open-order-details', o)"
                      class="h-9 w-[104px] px-3 bg-slate-800/80 text-slate-200 text-xs rounded-2xl border border-white/10
                             hover:bg-amber-400/10 hover:text-amber-100 hover:border-amber-400/30
                             transition-all duration-200 hover:scale-[1.03] font-bold
                             inline-flex items-center justify-center flex-none"
                  >
                    جزئیات
                  </button>

                  <button
                      @click="$emit('open-success-modal', o)"
                      class="w-9 h-9 bg-slate-800/80 text-slate-200 text-sm rounded-2xl border border-white/10
                             hover:bg-cyan-400/10 hover:text-cyan-100 hover:border-cyan-400/30
                             transition-all duration-200 inline-flex items-center justify-center flex-none"
                      title="نمایش فاکتور"
                  >
                    👀
                  </button>
                </div>
              </td>
            </tr>

            <!-- Empty State -->
            <tr v-if="!orders.items.length && !loading.orders">
              <td colspan="6" class="px-4 py-16 text-center">
                <div class="flex flex-col items-center justify-center text-slate-500">
                  <div
                      class="w-20 h-20 rounded-3xl border border-white/10 bg-slate-800/40
                             flex items-center justify-center mb-4"
                  >
                    <svg class="w-10 h-10 opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                  </div>

                  <p class="text-lg font-black text-slate-300">
                    سفارشی یافت نشد
                  </p>
                  <p class="text-sm mt-2 text-slate-500">
                    هیچ سفارشی مطابق با فیلترهای فعلی وجود ندارد
                  </p>
                </div>
              </td>
            </tr>

            <!-- Loading State -->
            <tr v-if="loading.orders">
              <td colspan="6" class="px-4 py-14 text-center">
                <div class="flex flex-col items-center justify-center text-slate-400">
                  <div
                      class="w-9 h-9 rounded-full border-2 border-slate-700 border-t-amber-400 animate-spin mb-3"></div>
                  <p class="text-sm">در حال دریافت سفارش‌ها...</p>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div
            class="flex flex-col md:flex-row md:items-center md:justify-between gap-3
                   p-4 border-t border-white/10 bg-slate-950/55 text-slate-200"
        >
          <div class="text-sm text-center md:text-right">
            صفحه
            <span class="font-black text-amber-300 mx-1">{{ orders.page }}</span>
            از
            <span class="font-black text-emerald-300 mx-1">{{ orders.total_pages }}</span>
          </div>

          <div class="flex flex-wrap items-center justify-center md:justify-end gap-2">
            <select
                v-model.number="localOrdersPageSize"
                @change="$emit('go-orders-page', 1)"
                class="h-10 w-[104px] px-3 border border-white/10 rounded-2xl text-sm bg-slate-800/80
                       focus:border-amber-400/50 focus:ring-2 focus:ring-amber-400/20 outline-none flex-none"
            >
              <option :value="10">10 مورد</option>
              <option :value="25">25 مورد</option>
              <option :value="50">50 مورد</option>
            </select>

            <button
                @click="$emit('go-orders-page', orders.page - 1)"
                :disabled="orders.page === 1"
                class="h-10 w-[82px] px-3 bg-slate-800/80 border border-white/10 rounded-2xl text-sm disabled:opacity-40
                       disabled:cursor-not-allowed hover:bg-slate-700/80 transition-all duration-200
                       inline-flex items-center justify-center gap-1.5 flex-none"
            >
              <svg class="w-4 h-4 flex-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
              قبلی
            </button>

            <button
                @click="$emit('go-orders-page', orders.page + 1)"
                :disabled="orders.page === orders.total_pages || !orders.total_pages"
                class="h-10 w-[82px] px-3 bg-slate-800/80 border border-white/10 rounded-2xl text-sm disabled:opacity-40
                       disabled:cursor-not-allowed hover:bg-slate-700/80 transition-all duration-200
                       inline-flex items-center justify-center gap-1.5 flex-none"
            >
              بعدی
              <svg class="w-4 h-4 flex-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosOrdersTab',

  props: {
    orders: {
      type: Object,
      required: true
    },
    ordersFilters: {
      type: Object,
      required: true
    },
    loading: {
      type: Object,
      required: true
    },
    statusBadgeClass: {
      type: Function,
      required: true
    },
    posStatusLabel: {
      type: Function,
      required: true
    }
  },

  methods: {
    returnType(order) {
      if (!order) return 'none'

      if (order.status === 're') return 'direct_full'
      if (order.return_type) return order.return_type

      const returned = Number(order.total_returned_amount || 0)
      const finalAmount = Number(order.final_amount || 0)
      const net = Number(this.displayFinalAmount(order) || 0)

      if (finalAmount > 0 && returned >= finalAmount) return 'full'
      if (net <= 0 && returned > 0) return 'full'
      if (returned > 0 || Number(order.returns_count || 0) > 0) return 'partial'

      return 'none'
    },

    returnTypeLabel(order) {
      const type = this.returnType(order)

      if (type === 'direct_full') return 'برگشت کامل مستقیم'
      if (type === 'full') return 'مرجوعی کامل سندی'
      if (type === 'partial') return 'مرجوعی جزئی سندی'

      return 'بدون مرجوعی'
    },

    returnTypeClass(order) {
      const type = this.returnType(order)

      if (type === 'direct_full') {
        return 'border-rose-400/30 bg-rose-500/10 text-rose-200'
      }

      if (type === 'full') {
        return 'border-pink-400/30 bg-pink-500/10 text-pink-200'
      }

      if (type === 'partial') {
        return 'border-orange-400/25 bg-orange-500/10 text-orange-200'
      }

      return 'border-slate-500/20 bg-slate-500/10 text-slate-300'
    },
    hasReturns(order) {
      return Boolean(
          order &&
          (
              order.status === 're' ||
              Number(order.total_returned_amount || 0) > 0 ||
              Number(order.returns_count || 0) > 0
          )
      )
    },

    displayFinalAmount(order) {
      if (
          order.net_amount_after_returns !== undefined &&
          order.net_amount_after_returns !== null &&
          order.net_amount_after_returns !== ''
      ) {
        return order.net_amount_after_returns
      }

      return order.final_amount || 0
    },

    customerInitial(order) {
      const name = order.customer_name || ''
      if (!name) return '؟'
      return String(name).trim().charAt(0)
    }
  },

  computed: {
    localOrdersFilters: {
      get() {
        return this.ordersFilters
      },
      set(value) {
        this.$emit('update:orders-filters', value)
      }
    },

    localOrdersPageSize: {
      get() {
        return this.orders.page_size
      },
      set(value) {
        this.$emit('update-orders-page-size', value)
      }
    }
  }
}
</script>